import { __rest } from "tslib";
import clsx from 'clsx';
import React from 'react';
export default function Positioner(_a) {
    var { width, style, size } = _a, props = __rest(_a, ["width", "style", "size"]);
    return (React.createElement("div", Object.assign({ style: width ? Object.assign({ width }, style) : style, className: clsx('modal__positioner', size && `modal--${size}`) }, props)));
}
//# sourceMappingURL=Positioner.js.map